import React from 'react'

import { MediumContainer } from 'component/Layout'
import { TestsessionView } from 'component/Course'

export const TestsessionPage = () => {
    return <MediumContainer>
        <TestsessionView />
    </MediumContainer>    
} 